import { ProductSpecificService } from '@feature/product/services/product-specific.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { Injectable } from "@angular/core";

@Injectable()
export class MojoDashboardProductService implements ProductSpecificService {
  product = MojoWellKnownNames.Products.MojoDashboard;
  adminDashboardRoute = '/mojo/admin/dashboard';
}
